import type { Landmark } from '../types/landmark';

export interface SplatManifestEntry {
  oerId: number;
  assetUrl: string;
  format: 'sog' | 'sog-meta' | 'ply' | 'compressed-ply';
  bytes: number;
  vertexCount: number;
  capturedAt: string;
  /** Start the viewer at the median-centroid (true) or backed off (false/undefined). */
  interior?: boolean;
  attribution: {
    source: string;
    sourceUrl?: string;
    license: string;
    licenseUrl?: string;
  };
}

export interface SplatManifest {
  version: string;
  generatedAt: string;
  entries: SplatManifestEntry[];
}

let cached: Promise<SplatManifest> | null = null;

export function loadSplatManifest(): Promise<SplatManifest> {
  if (!cached) {
    cached = fetch('/data/splats.json', { cache: 'no-cache' })
      .then((r) => {
        if (!r.ok) throw new Error(`splats.json fetch ${r.status}`);
        return r.json() as Promise<SplatManifest>;
      })
      .catch((err) => {
        cached = null;
        throw err;
      });
  }
  return cached;
}

export async function findSplatForLandmark(
  landmark: Pick<Landmark, 'oerId'>,
): Promise<SplatManifestEntry | null> {
  const manifest = await loadSplatManifest();
  return manifest.entries.find((e) => e.oerId === landmark.oerId) ?? null;
}
